var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("404!")]),_c('h4',[_vm._v("La page demandée n'a pas pu être trouvée!")])])}]

export { render, staticRenderFns }